import { createReducer } from "@reduxjs/toolkit";

import {
  setAuthors,
  blockAuthor,
  unblockAuthor,
  blockedByUserSuccess,
  unblockedByUserSuccess,
  makeAuthorDeleted,
} from "./actions";

/**
 * `[id]: author` object
 * @example
 * initialState: { 1: { id: 1, name: "Anton" }, 2: { id: 2, name: "John Doe" } }
 */
const initialState = {};

export default createReducer(initialState, (builder) => {
  builder
    .addCase(setAuthors.type, (state, action) => ({
      ...state,
      ...action.payload,
    }))
    .addCase(blockAuthor, (state, { payload }) => ({
      ...state,
      [payload.userId]: {
        ...state?.[payload.userId],
        isBlockedByYou: true,
      },
    }))
    .addCase(unblockAuthor, (state, { payload }) => ({
      ...state,
      [payload.userId]: {
        ...state?.[payload.userId],
        isBlockedByYou: false,
      },
    }))
    .addCase(blockedByUserSuccess.type, (state, { payload }) => ({
      ...state,
      [payload]: {
        ...state?.[payload],
        isBlockedByUser: true,
      },
    }))
    .addCase(unblockedByUserSuccess.type, (state, { payload }) => ({
      ...state,
      [payload]: {
        ...state?.[payload],
        isBlockedByUser: false,
      },
    }))
    .addCase(makeAuthorDeleted.type, (state, { payload }) => ({
      ...state,
      [payload]: {
        isDeleted: true,
        username: "Deleted user",
        id: state?.[payload]?.id,
        createdAt: state?.[payload]?.createdAt,
        updatedAt: state?.[payload]?.updatedAt,
      },
    }));
});
